"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeCompleteMeshRunRecord = exports.serializeCompleteMeshRunRecord = exports.deserializeGlobalMeshRunRecord = exports.serializeGlobalMeshRunRecord = exports.deserializeMeshRunRecord = exports.serializeMeshRunRecord = exports.deSerializeMeshInstance = exports.serializeMeshInstance = exports.deserializeMeshDocument = exports.serializeMeshDocument = void 0;
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
// Mesh Document
const serializeMeshDocument = (document) => {
    return JSON.stringify(document);
};
exports.serializeMeshDocument = serializeMeshDocument;
const deserializeMeshDocument = (str) => {
    return JSON.parse(str);
};
exports.deserializeMeshDocument = deserializeMeshDocument;
// Mesh instances
const serializeMeshInstance = (instance) => {
    return JSON.stringify(instance);
};
exports.serializeMeshInstance = serializeMeshInstance;
// used by FE to convert serialized instances to objects
const deSerializeMeshInstance = (str) => {
    // @datapipeline: add a typeguard.
    const parsedInstance = JSON.parse(str);
    const instance = {
        id: parsedInstance.id,
        artifactId: parsedInstance.artifactId,
        status: parsedInstance.status,
        updated_at: new Date(parsedInstance.updated_at),
        created_at: new Date(parsedInstance.created_at),
        statusDetails: parsedInstance.statusDetails,
        synthetic: parsedInstance.synthetic,
    };
    return instance;
};
exports.deSerializeMeshInstance = deSerializeMeshInstance;
const serializeMeshRunRecord = (instance) => {
    return JSON.stringify(instance);
};
exports.serializeMeshRunRecord = serializeMeshRunRecord;
const deserializeMeshRunRecord = (str) => {
    const parsedRecord = JSON.parse(str);
    const meshRunId = parsedRecord.meshRunId;
    const meshDocumentId = parsedRecord.meshDocumentId;
    (0, common_1.finleyAssert)(finley_types_1.DataPipeline.isMeshId(meshRunId), `Invalid [meshRunId: ${meshRunId}]`);
    (0, common_1.finleyAssert)(finley_types_1.DataPipeline.isMeshId(meshDocumentId), `Invalid [meshDocumentId: ${meshDocumentId}]`);
    const instance = {
        meshRunId,
        meshDocumentId,
        startedAt: new Date(parsedRecord.startedAt),
        updatedAt: new Date(parsedRecord.updatedAt),
        reportingDate: parsedRecord.reportingDate,
        fileVersion: parsedRecord.fileVersion,
        status: parsedRecord.status,
        cfSlugs: parsedRecord.cfSlugs,
        lpSlugs: parsedRecord.lpSlugs,
    };
    return instance;
};
exports.deserializeMeshRunRecord = deserializeMeshRunRecord;
const serializeGlobalMeshRunRecord = (instance) => {
    return JSON.stringify(instance);
};
exports.serializeGlobalMeshRunRecord = serializeGlobalMeshRunRecord;
const deserializeGlobalMeshRunRecord = (str) => {
    const parsedRecord = JSON.parse(str);
    const meshRunId = parsedRecord.meshRunId;
    const meshDocumentId = parsedRecord.meshDocumentId;
    (0, common_1.finleyAssert)(finley_types_1.DataPipeline.isMeshId(meshRunId), `Invalid [meshRunId: ${meshRunId}]`);
    (0, common_1.finleyAssert)(finley_types_1.DataPipeline.isMeshId(meshDocumentId), `Invalid [meshDocumentId: ${meshDocumentId}]`);
    const instance = {
        meshRunId,
        meshDocumentId,
        startedAt: new Date(parsedRecord.startedAt),
        updatedAt: new Date(parsedRecord.updatedAt),
        reportingDate: parsedRecord.reportingDate,
        fileVersion: parsedRecord.fileVersion,
        status: parsedRecord.status,
        cfSlugs: parsedRecord.cfSlugs,
        lpSlugs: parsedRecord.lpSlugs,
        organizationId: parsedRecord.organizationId,
        organizationSlug: parsedRecord.organizationSlug,
        implementationId: parsedRecord.implementationId,
        implementationSlug: parsedRecord.implementationSlug,
    };
    return instance;
};
exports.deserializeGlobalMeshRunRecord = deserializeGlobalMeshRunRecord;
const serializeCompleteMeshRunRecord = (instance) => {
    const preSerialize = {
        serializedMeshRecord: (0, exports.serializeMeshRunRecord)(instance.meshRunRecord),
        serializedInstances: instance.instances.map(exports.serializeMeshInstance),
        serializedMeshDocument: (0, exports.serializeMeshDocument)(instance.meshDocument),
    };
    return JSON.stringify(preSerialize);
};
exports.serializeCompleteMeshRunRecord = serializeCompleteMeshRunRecord;
const deserializeCompleteMeshRunRecord = (str) => {
    const parsedRecord = JSON.parse(str);
    return {
        meshRunRecord: (0, exports.deserializeMeshRunRecord)(parsedRecord.serializedMeshRecord),
        instances: parsedRecord.serializedInstances.map(exports.deSerializeMeshInstance),
        meshDocument: (0, exports.deserializeMeshDocument)(parsedRecord.serializedMeshDocument),
    };
};
exports.deserializeCompleteMeshRunRecord = deserializeCompleteMeshRunRecord;
//# sourceMappingURL=serialize.js.map